"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100svh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0B0C0E",
          color: "#F5F4F0",
          fontFamily: "ui-sans-serif, system-ui, sans-serif",
          padding: "2rem",
        }}
      >
        <div style={{ maxWidth: 560 }}>
          <p
            style={{
              fontFamily: "ui-monospace, monospace",
              fontSize: "0.75rem",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#8B9098",
              margin: 0,
            }}
          >
            Chyba aplikace
          </p>
          <h1
            style={{
              fontSize: "clamp(2rem, 6vw, 3.5rem)",
              lineHeight: 1.02,
              margin: "1.5rem 0 1rem",
              fontWeight: 400,
            }}
          >
            Něco se pokazilo.
          </h1>
          <p style={{ color: "#8B9098", lineHeight: 1.65, margin: 0 }}>
            Zkuste stránku načíst znovu. Pokud potíže přetrvají, napište nám na
            info@example.com.
          </p>
          {error.digest ? (
            <p
              style={{
                fontFamily: "ui-monospace, monospace",
                fontSize: "0.75rem",
                color: "#62666D",
                marginTop: "1rem",
              }}
            >
              Kód chyby: {error.digest}
            </p>
          ) : null}
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: "2rem",
              background: "#F5F4F0",
              color: "#0B0C0E",
              border: "none",
              padding: "0.875rem 1.5rem",
              fontFamily: "ui-monospace, monospace",
              fontSize: "0.8125rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
